//-================ IMPORTS FOR GENERAL COMPONENT ================-\\
import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';


//-================ IMPORTS FOR SERVICES ================-\\


//-================ IMPORTS FOR CONSTANTS ================-\\


//-================ IMPORTS FOR DEPENDENCIES ================-\\
import { TreeNode } from 'primeng/api';
import Swal from 'sweetalert2';
import { FILE_CCP } from 'src/app/Interfaces/Libraries/Library-CCP-Int/File_CCP.interface';
import { Folder_CCP_Path } from 'src/app/Interfaces/Libraries/Library-CCP-Int/Folder_CCP.interface';
import { File_Tree_CCP } from 'src/app/Interfaces/Libraries/Library-CCP-Int/Tree-Move-CCP.interface';
import { Response_CCP } from 'src/app/Interfaces/Interfaces-Global/Response.interface';
import { FileManagerLibCCPComponent } from '../../file-manager-lib-ccp/file-manager-lib-ccp.component';

//-================ IMPORTS FOR INTERFACES ================-\\

@Component({
    selector: 'app-tree-move-proces-ccp',
    templateUrl: './tree-move-proces-ccp.component.html',
    styleUrls: ['./tree-move-proces-ccp.component.scss', '../../../../../Styles/GlobalStyles.css', '../../../../../Styles/TreeMoveGlobal.scss'],
    standalone: false
})
export class TreeMoveProcesCCPComponent extends FileManagerLibCCPComponent implements OnInit {

  //-============== VARIABLES FOR TREE & SELECTED FILE ===============-\\

  //+===================== INPUTS =====================+\\
  @Input() override FCCP_Select_CM!: FILE_CCP;

  //+===================== OUTPUTS =====================+\\
  @Output() IsMoveCCP = new EventEmitter<boolean>();
  @Output() ShowSideBar = new EventEmitter<boolean>();


  //+===================== GENERAL TREE =====================+\\
  public loading: boolean = false;
  public files: Folder_CCP_Path[] = [];
  public treeNodes: TreeNode[] = this.files.map(file => {
    return {
      "label": 'Raiz',
      "data": '',
      "expandedIcon": 'fa-solid fa-folder-open',
      "collapsedIcon": "fa-solid fa-folder",
      "leaf": false,
      "children": [{
        "label": file.Name,
        "data": file.Path,
        "expandedIcon": 'fa-solid fa-folder-open',
        "collapsedIcon": "fa-solid fa-folder",
        "leaf": false,
        "children": []
      }]
    };
  });
  public files2: File_Tree_CCP[] = [];
  public selectedFile: any;


  public cd = inject(ChangeDetectorRef)

  override async ngOnInit() {
    this.LoadTree('');
  }


  //&===================== FUNCTIONS FOR LOAD COMPONENT =====================&\\

  //-================== FUNCTTION FOR LOAD TREE ==================-\\
  public async LoadTree(Path: ''): Promise<void> {
    try {

      this.loading = true;

      const ResDirectories: Response_CCP = await firstValueFrom(this.Service_CCP.Get_Dirs_In_Directory_CCP({ path: Path }));

      if (ResDirectories.success) {

        this.files = ResDirectories.operation;
        this.treeNodes = this.files.map((file: Folder_CCP_Path) => this.mapFileNode(file));
        this.loading = false;
        this.cd.markForCheck();

      }


    } catch (e) {
      Swal.fire({
        title: 'Ocurrió un error',
        text: '¡Notifique este error al supervisor!',
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      })
    }

  }

  //&===================== END FUNCTIONS FOR LOAD COMPONENT =====================&\\



  //&===================== FUNCTIONS FOR GENERAL COMPONENT =====================&\\

  //-================== FUNCTTION NODE EXPAND IN TREE ==================-\\
  public async nodeExpand(event: any): Promise<void> {

    const Node: TreeNode = event.node;

    this.loading = true;

    if (Node) {

      try {

        const childs_response: Response_CCP = await firstValueFrom(this.Service_CCP.Get_Dirs_In_Directory_CCP({ path: Node.data }));

        if (childs_response.success) {

          const Directories: Folder_CCP_Path[] = childs_response.operation;
          const newChildNodes: TreeNode[] = Directories.map((childFile: Folder_CCP_Path) => this.mapFileNode(childFile));

          this.updateTreeNodeChildren(this.treeNodes, Node.data, newChildNodes);
          this.cd.markForCheck();

          this.loading = false;
        }


      } catch (e) {

        Swal.fire({
          title: 'Ocurrió un error',
          text: '¡Notifique este error al supervisor!',
          icon: 'warning',
          confirmButtonColor: this.ColorConfirm
        })
      }

    }
  }

  //-================== FUNCTTION FOR MAP DIRECTORY ==================-\\
  private mapFileNode(file: Folder_CCP_Path): TreeNode {
    return {
      label: file.Name,
      data: file.Path,
      expandedIcon: "fa-solid fa-folder-open",
      collapsedIcon: "fa-solid fa-folder",
      leaf: false,
      children: []
    };
  }

  //-================== FUNCTTION FOR SET CHILDREN DIRECTORY ==================-\\
  private updateTreeNodeChildren(nodes: TreeNode[], nodeData: string, newChildNodes: TreeNode[]): void {
    for (const node of nodes) {
      if (node.data === nodeData) {
        node.children = newChildNodes;
        return;
      }

      if (node.children && node.children.length > 0) {
        this.updateTreeNodeChildren(node.children, nodeData, newChildNodes);
      }
    }
  }

  //&===================== END FUNCTIONS FOR GENERAL COMPONENT =====================&\\




  //&===================== FUNCTIONS FOR SAVE OR CANCEL =====================&\\

  //-================== FUNCTTION FOR MOVE PROCESS ==================-\\
  public async Move_Process_to_Directorie(): Promise<void> {

    if (!this.selectedFile) {
      Swal.fire({
        title: "Sin carpeta destino",
        text: "Por favor seleccione una carpeta para moverlo",
        icon: "info"
      });
    }
    else {
      this.FCCP_Select_CM.Directory ? this.Move_Directory_to_Directory() : this.Move_Process_To_Dir();
    }

  }

  //-================== FUNCTTION FOR MOVE PROCESS ==================-\\
  public async Move_Process_To_Dir(): Promise<void> {

    if (!this.selectedFile) {
      Swal.fire({
        title: "Sin carpeta destino",
        text: "Por favor seleccione una carpeta para moverlo",
        icon: "info"
      });
    }
    else {

      const NameFolder: string = (this.selectedFile.label)?.trim() || '';

      Swal.fire({
        title: `¿Está seguro de querer mover la CCP a la carpeta "${NameFolder}"?`,
        text: "¡la HOE será reubicado en la carpeta destino!",
        icon: 'info',
        showCancelButton: true,
        confirmButtonColor: this.ColorConfirm,
        cancelButtonColor: this.ColorsCancel,
        confirmButtonText: '¡Sí, mover!'
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire({
            title: 'Nuevamente ¿Está seguro?!',
            text: `¡Marque la casilla para mover la HOE!`,
            input: 'checkbox',
            inputPlaceholder: 'Mover Proceso',
            confirmButtonText: 'Continuar <i class="fa-solid fa-right-long"></i>',
            confirmButtonColor: this.ColorConfirm,
            cancelButtonColor: this.ColorsCancel,
            showCancelButton: true,
          }).then((async (result2: any) => {

            if (result.isConfirmed) {

              if (result2.value === 1) {

                try {

                  const ResMoveRBin: Response_CCP = await firstValueFrom(this.Service_CCP.Move_Process_CCP({ path: this.selectedFile.data, ID_WF: this.FCCP_Select_CM.ID }))

                  if (ResMoveRBin.success) {

                    Swal.fire({
                      icon: 'success',
                      title: 'Proceso reubicado',
                      text: '¡Se reubicó correctamente la HOE en la carpeta seleccionada!',
                      confirmButtonColor: this.ColorConfirm
                    });
                    this.Cancel_Movement();
                    this.IsMoveCCP.emit(true);
                  }


                } catch (e) {
                  Swal.fire({
                    icon: 'warning',
                    title: 'Error al reubicar la HOE',
                    text: '¡No se reubicó la HOE, notifica a tu supervisor!',
                    confirmButtonColor: this.ColorConfirm
                  });
                  this.Cancel_Movement();
                  this.IsMoveCCP.emit(true);

                }

              } else {
                Swal.fire({
                  icon: 'warning',
                  title: 'Sin confirmar',
                  text: '¡Marque la casilla para restaurar la HOE!',
                  confirmButtonColor: this.ColorConfirm
                });

              }

            }

          }))
        }
      })
    }

  }

  private Move_Directory_to_Directory(): void {

    const Path_Src = this.FCCP_Select_CM.Path;
    const Path_Des = this.selectedFile.data;

    const ID_Folder_Src: number = this.FCCP_Select_CM.ID;
    const ID_Folder_Des: number = Number((this.selectedFile.data.split('/').pop()).split('§').shift());

    if (Path_Src === Path_Des) {

      Swal.fire({
        title: "No es posible mover esta carpeta",
        text: "Está intentando mover la carpeta al mismo destino.",
        icon: "warning",
        confirmButtonColor: this.ColorConfirm
      });

    } else {

      const NameFolder: string = (this.selectedFile.label)?.trim() || '';
      const NameFolder_Move: string = (this.FCCP_Select_CM.Name)?.trim() || '';

      Swal.fire({
        title: `¿Está seguro de que desea mover la carpeta a la carpeta "${NameFolder}"?`,
        text: "La carpeta será reubicada en la carpeta destino.",
        icon: 'info',
        showCancelButton: true,
        confirmButtonColor: this.ColorConfirm,
        cancelButtonColor: this.ColorsCancel,
        confirmButtonText: '¡Sí, mover!'
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire({
            title: '¿Está seguro nuevamente?',
            text: `¡Para proceder con la operación de mover la carpeta, por favor ingrese '${NameFolder_Move}'.!`,
            input: 'text',
            confirmButtonText: 'Continuar <i class="fa-solid fa-right-long"></i>',
            confirmButtonColor: this.ColorConfirm,
            cancelButtonColor: this.ColorsCancel,
            showCancelButton: true,
          }).then((async result2 => {

            if (result2.isConfirmed) {

              const ValueInput: string = result2.value;

              if (ValueInput.toLowerCase() === NameFolder_Move.toLowerCase()) {


                try {

                  const Res_Move_Dir: Response_CCP = await firstValueFrom(this.Service_CCP.Move_Dir_To_Dir_CCP({ ID_Folder_Src: ID_Folder_Src, ID_Folder_Des: ID_Folder_Des }))

                  if (Res_Move_Dir.success) {
                    Swal.fire({
                      icon: 'success',
                      title: 'Carpeta reubicada exitosamente',
                      text: 'La carpeta se ha movido correctamente al directorio seleccionado.',
                      confirmButtonColor: this.ColorConfirm
                    });
                    this.Cancel_Movement();
                    this.IsMoveCCP.emit(true);

                  } else {
                    throw Res_Move_Dir.message;
                  }


                } catch (error) {
                  Swal.fire({
                    title: 'Ocurrió un error',
                    text: '¡Recargue la página, si el problema persiste notifique a supervisor!',
                    icon: 'warning',
                    confirmButtonColor: this.ColorConfirm
                  })
                  this.Cancel_Movement();
                  this.IsMoveCCP.emit(true);

                }

              } else {
                Swal.fire({
                  icon: 'warning',
                  title: 'Sin coincidencias encontradas',
                  text: 'Por favor, asegúrese de escribir correctamente el nombre de la carpeta para proceder con la operación.',
                  confirmButtonColor: this.ColorConfirm
                });

              }
            }
          }))
        }
      })
    }


  }

  //-================== FUNCTTION FOR CANCEL MOVE ==================-\\
  public async Cancel_Movement(): Promise<void> {

    this.ShowSideBar.emit(false);

    this.files = [
      {
        ID: 0,
        Name: '',
        ID_Folder_Top: 0,
        status: 0,
        Directory: false,
        Inheritance: 0,
        Path: ''
      }
    ];

    this.selectedFile = undefined;

    await this.LoadTree('');

    this.cd.markForCheck();
  }

  //&===================== END FUNCTIONS FOR SAVE OR CANCEL =====================&\\
}
